import Swiper from 'swiper';
import {Autoplay, EffectFade, Navigation, Pagination} from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/effect-fade';
import {initEstateSlider} from './estate-slider.js';

function main() {
    // ヒーロースライダー
    const heroSlider = document.querySelector('.pg-home-hero__slider');
    const heroSlides = heroSlider ? heroSlider.querySelectorAll('.swiper-slide') : [];
    if (heroSlider && heroSlides.length <= 1) {
        const pagination = document.querySelector('.pg-home-hero-pagination');
        if (pagination) pagination.style.display = 'none';
    }
    if (heroSlider && heroSlides.length > 1) {
        new Swiper(heroSlider, {
            modules: [Autoplay, EffectFade, Pagination],
            effect: 'fade',
            fadeEffect: {
                crossFade: true,
            },
            loop: true,
            autoplay: {
                delay: 5000,
                disableOnInteraction: false,
            },
            speed: 1000,
            pagination: {
                el: '.pg-home-hero-pagination',
                clickable: true,
            },
        });
    }

    // お客様の声スライダー
    const voiceSlider = document.querySelector('.pg-home-voice__slider');
    if (voiceSlider) {
        const progressBar = document.querySelector('.pg-home-voice__progress-bar');
        // loop は breakpoints 内では切り替えられないため、初期化時の画面幅で判定する
        const isDesktop = window.matchMedia('(min-width: 1024px)').matches;

        new Swiper(voiceSlider, {
            modules: [Autoplay],
            speed: 500,
            loop: isDesktop,
            autoplay: {
                delay: 3000,
                disableOnInteraction: false,
            },
            breakpoints: {
                0: {
                    spaceBetween: 20,
                    slidesPerView: 'auto',
                },
                1024: {
                    spaceBetween: 32,
                    slidesPerView: 'auto',
                },
            },
            on: {
                progress(swiper, progress) {
                    if (progressBar) {
                        const percent = Math.max(10, progress * 100);
                        progressBar.style.width = percent + '%';
                    }
                },
            },
        });
    }

    // ギャラリースライダー
    const gallerySlider = document.querySelector('.pg-home-gallery__slider');
    if (gallerySlider) {
        new Swiper(gallerySlider, {
            loop: true,
            modules: [Navigation, Autoplay],
            speed: 500,
            navigation: {
                prevEl: '.pg-home-gallery__nav .c-commons-swiper-navigation__prev',
                nextEl: '.pg-home-gallery__nav .c-commons-swiper-navigation__next',
            },
            autoplay: {
                delay: 3000,
                disableOnInteraction: false,
            },

            breakpoints: {
                0: {
                    slidesPerView: 1.9,
                    spaceBetween: 20,
                },
                1024: {
                    slidesPerView: 3.4,
                    spaceBetween: 40,
                },
            },
        });
    }

    // おすすめ物件スライダー
    initEstateSlider({
        sliderSelector: '.pg-home-recommended-properties__slider',
        prevEl: '.pg-home-recommended-properties__nav .c-commons-swiper-navigation__prev',
        nextEl: '.pg-home-recommended-properties__nav .c-commons-swiper-navigation__next',
    });

    // 新着物件スライダー
    initEstateSlider({
        sliderSelector: '.pg-home-latest-properties__slider',
        prevEl: '.pg-home-latest-properties__nav .c-commons-swiper-navigation__prev',
        nextEl: '.pg-home-latest-properties__nav .c-commons-swiper-navigation__next',
    });
}

export default main;
